var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"footer-hide":true},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }